"use strict";

import getNgModule from "getNgModule";

const ngModule = getNgModule(__filename);

ngModule.directive("obsTaelysIncentive", function($interval, $window) {
    var CAROUSEL_INTERVAL_DELAY = 6500;
    return {
        restrict : "E",
        scope : true,
        replace : true,
        template : require("./obsTaelysIncentive.html"),
        link : function($scope, $el, $attrs, ctrl) {
            ctrl.startCarousel();

            $scope.redirectToCommuneInfoPage = function() {
                $window.location.href = "https://www.taelys.com?pageId=offreSecteurPublic";
            };

        },
        controller : function($scope, $element) {

            var ctrl = this;

            var currentItemIdx  = -1,
                carouselEl      = $element.find(".carousel"),
                carouselItems   = carouselEl.find(".carousel-item");

            ctrl.startCarousel = function() {
                carouselItems.hide();
                ctrl.switchToItem(0);
                startInterval();
            };

            ctrl.switchToItem = function(itemIdx) {

                var scrollHeight = carouselEl.height();

                if(currentItemIdx > -1) {
                    var previousItem = carouselItems.eq(currentItemIdx);
                    previousItem.animate({
                        top: "-=" + scrollHeight + "px"
                    }, 500, "easeInOutCubic", function() {
                        previousItem.hide();
                    });
                }

                var nextItem = carouselItems.eq(itemIdx);
                nextItem.css({
                        position : "absolute",
                    top: "+" + scrollHeight + "px"
                    })
                    .show()
                    .animate({
                        top: "-=" + scrollHeight + "px"
                    }, 500, "easeInOutCubic");

                currentItemIdx = itemIdx;
            };

            ctrl.switchToNext = function() {
                var nextIdx = currentItemIdx === carouselItems.length -1 ? 0 : currentItemIdx + 1;
                ctrl.switchToItem(nextIdx);
            };

            var startInterval = function() {
                $interval(function() {
                    ctrl.switchToNext();
                }, CAROUSEL_INTERVAL_DELAY);
            };

        }
    };
});


// WEBPACK FOOTER //
// ./src/apps/observatoire/ng/incentive/obsTaelysIncentive.js